import React from 'react'

import { BrowserRouter as Router } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { AppContext, useAppContextValue } from './helpers/app'

import AppBase from './AppBase'
import 'react-toastify/dist/ReactToastify.css'

const App: React.FC = () => {
  const appContextAPIValue = useAppContextValue()

  return (
    <AppContext.Provider value={appContextAPIValue}>
      <Router>
        <AppBase />
      </Router>
      <ToastContainer theme="colored" position="bottom-right" />
    </AppContext.Provider>
  )
}

export default App
